import SplitterUI from "../../components/Patchs/SplitterUI";
import { Patcher } from "./";

export class Splitter implements Patcher {
    name: string;

    constructor() {
        this.name = '-';
    }

    get uiOnly(): boolean {
        return true;
    }

    ui() {
        return SplitterUI();
    }

    update() { }
    applyPatch() { }
    exportPatch(): undefined { }
    exportPatch2X(): undefined { }
    validatePatch() {
        return { valid: false };
    }
}
